module.exports = __webpack_public_path__ + "img/monitor-guest.97ebff42.jpg";